export default __webpack_public_path__ + "static/media/Expand.ba0ce245.svg";